import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Draggable } from 'react-beautiful-dnd';
import { getLandingPageUrl } from '../../../../helpers/soundcasts';
import Subscribers from './Subscribers';
import {
  SoundcastRow,
  SoundcastDrag,
  SoundcastInfo,
  SoundcastImage,
  SoundcastDescription,
  SoundcastUpdated,
  SoundcastLinksRow,
  SoundcastLinks,
  SoundcastStatus,
  SoundcastSubscribers,
  SoundcastActionButton,
} from './styled';

const getDraggableItemStyle = (isDragging, draggableStyle) => ({
  // background: isDragging ? "lightgreen" : "grey",
  ...draggableStyle,
});

export default class SoundcastBundleDraggable extends Component {
  render() {
    const { soundcast, index, onNonPaymentSignup, onEdit, onDelete } = this.props;

    const { landingPage, prices } = soundcast;
    const isPrivate = soundcast.published && !soundcast.landingPage;

    const preStatusTxt = soundcast.published ? 'Published' : 'Draft';
    const chargeState = soundcast.forSale ? 'For Sale' : 'Free';
    const preStateTxt = isPrivate ? 'Private' : chargeState;
    const soundcastStatus = soundcast.published ? [preStatusTxt, preStateTxt] : [preStatusTxt];

    return (
      <Draggable
        key={`bundle-${soundcast.id}`}
        draggableId={`bundle-${soundcast.id}`}
        index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getDraggableItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
            <SoundcastRow className="row" key={index}>
              <SoundcastDrag className=" col-md-1 col-sm-1 col-xs-1">
                 <i className="material-icons">drag_handle</i>
              </SoundcastDrag>
              <SoundcastInfo className=" col-md-8 col-sm-11 col-xs-11">
                <div className="row">
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <SoundcastImage src={soundcast.imageURL} alt="image" />
                  </div>
                  <SoundcastDescription className="col-md-7 col-sm-6 col-xs-10">
                    <span>{soundcast.title}</span>
                    {(soundcast.last_update && (
                      <React.Fragment>
                        <SoundcastUpdated>
                          Last updated: {moment(soundcast.last_update * 1000).format('MMM DD YYYY')}
                        </SoundcastUpdated>
                        <SoundcastStatus published={soundcast.published}>
                          {soundcastStatus.join(', ')}
                        </SoundcastStatus>
                      </React.Fragment>
                    )) ||
                      null}
                  </SoundcastDescription>
                  <SoundcastSubscribers className="col-md-3 col-sm-4 col-xs-12">
                    <Subscribers soundcast={soundcast} />
                  </SoundcastSubscribers>
                </div>
                <SoundcastLinksRow className="row">
                  <div className="col-md-12">
                    <SoundcastLinks disableSignup={soundcast.disableSignup}>
                      {landingPage && (
                        <a
                          className="landing-page-link"
                          target="_blank"
                          href={getLandingPageUrl(soundcast.id, soundcast.published)}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast landing page">
                            <strong>Landing page</strong>
                          </span>
                        </a>
                      )}
                      {(landingPage || isPrivate) && (
                        <a
                          className="non-payment-signup-link"
                          target="_blank"
                          onClick={onNonPaymentSignup}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast signup form">
                            <strong>Non-payment signup</strong>
                          </span>
                        </a>
                      )}
                      {landingPage && prices && prices[0].price > 0 && (
                        <a
                          className="checkout-page-link"
                          target="_blank"
                          href={`/soundcast_checkout?soundcast_id=${soundcast.id}`}>
                          <span
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="view soundcast checkout form">
                            <strong>Checkout page</strong>
                          </span>
                        </a>
                      )}
                      <span className="text-dark-gray" onClick={onDelete}>
                        Delete
                      </span>
                    </SoundcastLinks>
                  </div>
                </SoundcastLinksRow>
              </SoundcastInfo>
              <SoundcastInfo className="col-md-3 col-sm-12 col-xs-12">
                <SoundcastActionButton
                  className="col-md-2 col-sm-2 col-xs-12"
                  borderWidth={'0px'}
                  paddingTop={'0px'}>
                  <span
                    datatoggle="tooltip"
                    dataplacement="top"
                    title="edit soundcast"
                    onClick={onEdit}>
                    Edit
                  </span>
                </SoundcastActionButton>
              </SoundcastInfo>
            </SoundcastRow>
          </div>
        )}
      </Draggable>
    );
  }
}

SoundcastBundleDraggable.propTypes = {
  index: PropTypes.number,
  soundcast: PropTypes.object,
  onNonPaymentSignup: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

SoundcastBundleDraggable.defaultProps = {
  index: 0,
  soundcast: null,
  onNonPaymentSignup: () => {},
  onEdit: () => {},
  onDelete: () => {},
};
